/* This file is used to change or hide images for different languages */

/* ----- FRENCH ----- */

// Hover images
document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/fr/') || window.location.pathname.endsWith('/fr')) {
        const urlPairs = {
            "Overlay-G5_The_Dietary_Supplement_500ml_-_Enhance_Longevity.jpg" : "OVERLAY-.1-_G5_The_Dietary_Supplement_500ml.jpg",
            "Overlay-G5_The_Cream_with_MMST_50ml_-_Boost_Collagen.jpg" : "OVERLAY-7-G5_The_Cream_with_MMST_50ml.jpg",
            "TEST_HOVER_IMAGE-1-72PPI-COMPRESSED.jpg" : "OVERLAY-5-G5_The_Joint_Care_Cream_100ml.jpg",
            "Overlay-G5_The_Dietary_Supplement_1000ml_-_Enhance_Longevity.jpg" : "OVERLAY-2-G5_The_Dietary_Supplement_1000ml.jpg",
            "Overlay-G5_The_Joint_Care_Cream_500ml_-_Support_Joints.jpg" : "OVERLAY-6-G5_The_Joint_Care_Cream_500ml.jpg",
            "Overlay-G5_Perfect_Stocking_Fillers.jpg" : "OVERLAY-18-G5_Perfect_Stocking_Fillers.jpg",
            "Overlay-G5_CollagenBundle.jpg" : "OVERLAY-16-G5_Collagen_Bundle.jpg",
            "Overlay-G5_Sports_Recovery_Bundle_929e77b6-2461-4090-8b03-392510d18f54.jpg" : "OVERLAY-15-G5_Sports_Recovery_Bundle.jpg",
            "Overlay-G5_LongevityBundle.jpg" : "OVERLAY-14-G5_Longevity_Bundle.jpg",
            "Overlay-G5_Joint_Care_Bundle.jpg" : "OVERLAY-13-G5_Joint_Care_Bundle.jpg",
            "Overlay-G5_The_Lotion_with_MMST_200ml_-_Regenerate_Skin.jpg" : "OVERLAY-8-G5_The_Lotion_with_MMST_200ml.jpg",
            "Overlay-G5_The_Cleanser_with_MMST_200ml_-_Purify_Skin.jpg" : "OVERLAY-10-G5_The_Cleanser_with_MMST_200ml.jpg",
            "Overlay-G5_The_Mist_with_MMST_100ml_-_Revitalise_Skin.jpg" : "OVERLAY-9-G5_The_Mist_with_MMST_100ml.jpg",
            "Overlay-G5_Winter_Wellness_Gift_Collection.jpg" : "OVERLAY-20-G5_Winter_Wellness_Gift_Collection.jpg",
            "Overlay-G5_The_Gel_100ml_-_Soothe_Skin.jpg" : "OVERLAY-3-G5_The_Gel_100ml.jpg",
            "Overlay-G5_Christmas_Luxury_Skin_Collection.jpg" : "OVERLAY-19-_G5_Christmas_Luxury_Skin_Collection.jpg",
            "Overlay-G5_Haute_Cosmetiques_Bundle.jpg" : "OVERLAY-12-G5_Haute_Cosmetiques_Bundle.jpg",
            "Overlay-G5_The_Balm_100ml_-_Repair_Skin.jpg" : "OVERLAY-4-G5_The_Balm_100ml.jpg",
            "Overlay-G5_Wellbeing_Starter_Bundle.jpg" : "OVERLAY-11-G5_Wellbeing_Starter_Bundle.jpg",
            "Overlay-Buy_3_Get_One_Free.jpg" : "OVERLAY-17-Buy_3_Get_One_Free.jpg"
        };

        function updateImages() {
            const images = document.querySelectorAll('.product-block__image img');
            images.forEach((img) => {
                ['src', 'srcset'].forEach(attr => {
                    let val = img.getAttribute(attr);
                    if (!val) return;
                    if (attr === 'src') {
                        const updated = replaceFilename(val);
                        if (updated !== val) img.setAttribute(attr, updated);
                    } else if (attr === 'srcset') {
                        const updated = val.split(',')
                            .map(part => replaceFilename(part.trim()))
                            .join(', ');
                        img.setAttribute(attr, updated);
                    }
                });
            });
        }

        function replaceFilename(url) {
            const [path, query = ''] = url.split('?');
            const filename = path.split('/').pop();
            const dirname = path.substring(0, path.length - filename.length);
            const replacement = urlPairs[filename];
            if (replacement) {
                return `${dirname}${replacement}${query ? '?' + query : ''}`;
            }
            return url;
        }

        updateImages();

        setTimeout(updateImages, 1000);

        const cartLink = document.querySelector('.cart-link');
        if (cartLink) {
            cartLink.addEventListener('click', function () {
                setTimeout(updateImages, 500);
            });
        }
    }
});


// Locale images
document.addEventListener('DOMContentLoaded', function () {
    const isFrenchLocale =
        window.location.pathname.includes('/fr/') ||
        window.location.pathname.endsWith('/fr');

    const frOnlyImages = [
        "67732860174681",
        "67732860207449",
        "67732860240217",
        "67732860272985",
        "67732860338521",
        "67732860371289"
    ];

    function enforceFrOnlyImages() {
        document.querySelectorAll(`
            .gallery-viewer__thumbs .gallery-viewer__thumb,
            .media-gallery__inner .slider__item,
            .product-block__image
        `).forEach(item => {
            const mediaId = item.getAttribute('data-media-id');
            if (!mediaId) return;

            if (frOnlyImages.includes(mediaId)) {
                if (isFrenchLocale) {
                    item.style.display = ''; // show
                } else {
                    item.style.display = 'none';
                }
            }
        });
    }

    enforceFrOnlyImages();

    const observer = new MutationObserver(() => {
        enforceFrOnlyImages();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  
    const mainImage = document.querySelector('.main-image');
    if (mainImage) {
        mainImage.addEventListener('click', () => {
            let attempts = 0;
            const maxAttempts = 20;

            const interval = setInterval(() => {
                enforceFrOnlyImages();
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 300);
        });
    }

    document.querySelectorAll('.product-block').forEach(block => {
        block.addEventListener('click', () => {
            let attempts = 0;
            const maxAttempts = 20;
            const interval = setInterval(() => {
                enforceFrOnlyImages();
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 300);
        });
    });
});

/* ----- END OF FRENCH ----- */

/* ----- ENGLISH ----- */

// Locale images
document.addEventListener('DOMContentLoaded', function () {
    const path = window.location.pathname;
    const isDefaultLocale = !/^\/[a-z]{2}(\/|$)/.test(path);

    if (!isDefaultLocale) {
        const imageKeysToHide = [
            "67203196748121",
            "67244601213273",
            "67244610814297",
            "67244625592665",
            "67244625658201",
            "67244625690969",
            "67244625723737",
            "67244658098521",
            "67247107113305"
        ];

        function hideThumbImages() {
            document.querySelectorAll('.gallery-viewer__thumbs .gallery-viewer__thumb').forEach(item => {
                const mediaId = item.getAttribute('data-media-id');
                if (mediaId && imageKeysToHide.includes(mediaId)) {
                    item.style.display = 'none';
                }
            });
        }

        function hideSliderImages() {
            document.querySelectorAll('.media-gallery__inner .slider__item').forEach(item => {
                const mediaId = item.getAttribute('data-media-id');
                if (mediaId && imageKeysToHide.includes(mediaId)) {
                    item.style.display = 'none';
                }
            });
        }

        hideThumbImages();
        hideSliderImages();

        const mainImage = document.querySelector('.main-image');
        if (mainImage) {
            mainImage.addEventListener('click', () => {
                let attempts = 0;
                const maxAttempts = 20;

                const interval = setInterval(() => {
                    const gallery = document.querySelector('.gallery-viewer__thumbs');
                    const sliders = document.querySelectorAll('.gallery-viewer__thumbs .gallery-viewer__thumb');

                    if (gallery && sliders.length > 0) {
                        hideThumbImages();
                        clearInterval(interval);
                    }

                    attempts++;
                    if (attempts >= maxAttempts) {
                        clearInterval(interval);
                    }
                }, 300);
            });
        }

        document.querySelectorAll('.product-block__image').forEach(item => {
            const mediaId = item.getAttribute('data-media-id');
            if (mediaId && imageKeysToHide.includes(mediaId)) {
                item.remove();
            }
        });

        document.querySelectorAll('.product-block').forEach(block => {
            block.addEventListener('click', () => {
                let attempts = 0;
                const maxAttempts = 20;
                const interval = setInterval(() => {
                    const gallery = document.querySelector('.media-gallery__inner');
                    const sliders = document.querySelectorAll('.media-gallery__inner .slider__item');

                    if (gallery && sliders.length > 0) {
                        hideSliderImages();
                        clearInterval(interval);
                    }

                    attempts++;
                    if (attempts >= maxAttempts) {
                        clearInterval(interval);
                    }
                }, 300);
            });
        });
    }
});

/* ----- END OF ENGLISH ----- */

/* ----- ITALIAN ----- */

// Hover images
document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/it/') || window.location.pathname.endsWith('/it')) {
        const urlPairs = {
            "Overlay-G5_The_Dietary_Supplement_500ml_-_Enhance_Longevity.jpg" : "IT-G5_Integratore_alimentare_1000ml.jpg",
            "Overlay-G5_The_Cream_with_MMST_50ml_-_Boost_Collagen.jpg" : "IT-G5_Crema_con_MMST_50ml.jpg",
            "TEST_HOVER_IMAGE-1-72PPI-COMPRESSED.jpg" : "IT-G5_Crema_per_le_articolazioni.jpg",
            "Overlay-G5_The_Dietary_Supplement_1000ml_-_Enhance_Longevity.jpg" : "IT-G5_Integratore_alimentare_1000ml.jpg",
            "Overlay-G5_The_Joint_Care_Cream_500ml_-_Support_Joints.jpg" : "IT-G5_Crema_per_le_articolazioni.jpg",
            "Overlay-G5_CollagenBundle.jpg" : "IT-Pacchetto_G5_per_il_collagene.jpg",
            "Overlay-G5_Sports_Recovery_Bundle_929e77b6-2461-4090-8b03-392510d18f54.jpg" : "IT-Pacchetto_G5_per_il_recupero_dopo_lo_sport.jpg",
            "Overlay-G5_LongevityBundle.jpg" : "IT-Pacchetto_G5_per_la_longevita.jpg",
            "Overlay-G5_Joint_Care_Bundle.jpg" : "IT-Pacchetto_G5_per_il_benessere_delle_articolazioni.jpg",
            "Overlay-G5_The_Lotion_with_MMST_200ml_-_Regenerate_Skin.jpg" : "IT-G5_Lozione_con_MMST_200ml.jpg",
            "Overlay-G5_The_Cleanser_with_MMST_200ml_-_Purify_Skin.jpg" : "IT-G5_Detergente_con_MMST_200ml.jpg",
            "Overlay-G5_The_Mist_with_MMST_100ml_-_Revitalise_Skin.jpg" : "IT-G5_Spray_con_MMST_100ml.jpg",
            "Overlay-G5_The_Gel_100ml_-_Soothe_Skin.jpg" : "IT-G5_Gel_100ml.jpg",
            "Overlay-G5_Haute_Cosmetiques_Bundle.jpg" : "IT-Pacchetto_G5_Haute_Cosmetiques.jpg",
            "Overlay-G5_The_Balm_100ml_-_Repair_Skin.jpg" : "IT-G5_Unguento_100ml.jpg",
            "Overlay-G5_Wellbeing_Starter_Bundle.jpg" : "IT-Pacchetto_base_G5_Benessere.jpg",
            "Overlay-Buy_3_Get_One_Free.jpg" : "OVERLAY-17-Buy_3_Get_One_Free.jpg"
        };

        function updateImages() {
            const images = document.querySelectorAll('.product-block__image img');
            images.forEach((img) => {
                ['src', 'srcset'].forEach(attr => {
                    let val = img.getAttribute(attr);
                    if (!val) return;
                    if (attr === 'src') {
                        const updated = replaceFilename(val);
                        if (updated !== val) img.setAttribute(attr, updated);
                    } else if (attr === 'srcset') {
                        const updated = val.split(',')
                            .map(part => replaceFilename(part.trim()))
                            .join(', ');
                        img.setAttribute(attr, updated);
                    }
                });
            });
        }

        function replaceFilename(url) {
            const [path, query = ''] = url.split('?');
            const filename = path.split('/').pop();
            const dirname = path.substring(0, path.length - filename.length);
            const replacement = urlPairs[filename];
            if (replacement) {
                return `${dirname}${replacement}${query ? '?' + query : ''}`;
            }
            return url;
        }

        updateImages();

        setTimeout(updateImages, 1000);

        const cartLink = document.querySelector('.cart-link');
        if (cartLink) {
            cartLink.addEventListener('click', function () {
                setTimeout(updateImages, 500);
            });
        }
    }
});


// Locale images
document.addEventListener('DOMContentLoaded', function () {
    const isItLocale =
        window.location.pathname.includes('/it/') ||
        window.location.pathname.endsWith('/it');

    const ItOnlyImages = [
        "67734717956441",
        "67734717170009",
        "67734717858137",
        "67734717825369",
        "67734717890905",
        "67734718021977"
    ];

    function enforceItOnlyImages() {
        document.querySelectorAll(`
            .gallery-viewer__thumbs .gallery-viewer__thumb,
            .media-gallery__inner .slider__item,
            .product-block__image
        `).forEach(item => {
            const mediaId = item.getAttribute('data-media-id');
            if (!mediaId) return;

            if (ItOnlyImages.includes(mediaId)) {
                if (isItLocale) {
                    item.style.display = ''; // show
                } else {
                    item.style.display = 'none';
                }
            }
        });
    }

    enforceItOnlyImages();

    const observer = new MutationObserver(() => {
        enforceItOnlyImages();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  
    const mainImage = document.querySelector('.main-image');
    if (mainImage) {
        mainImage.addEventListener('click', () => {
            let attempts = 0;
            const maxAttempts = 20;

            const interval = setInterval(() => {
                enforceItOnlyImages();
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 300);
        });
    }

    document.querySelectorAll('.product-block').forEach(block => {
        block.addEventListener('click', () => {
            let attempts = 0;
            const maxAttempts = 20;
            const interval = setInterval(() => {
                enforceItOnlyImages();
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 300);
        });
    });
});

/* ----- END OF ITALIAN ----- */

/* ----- SPANISH ----- */

// Hover images
document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/es/') || window.location.pathname.endsWith('/es')) {
        const urlPairs = {
            "Overlay-G5_The_Dietary_Supplement_500ml_-_Enhance_Longevity.jpg" : "ES-Suplemento_dietetico_G5.jpg",
            "Overlay-G5_The_Cream_with_MMST_50ml_-_Boost_Collagen.jpg" : "ES-Crema_con_MMST_G5_50_ml.jpg",
            "TEST_HOVER_IMAGE-1-72PPI-COMPRESSED.jpg" : "ES-Crema_de_cuidado_articular_G5.jpg",
            "Overlay-G5_The_Dietary_Supplement_1000ml_-_Enhance_Longevity.jpg" : "ES-Suplemento_dietetico_G5.jpg",
            "Overlay-G5_The_Joint_Care_Cream_500ml_-_Support_Joints.jpg" : "ES-Crema_de_cuidado_articular_G5.jpg",
            "Overlay-G5_Perfect_Stocking_Fillers.jpg" : "OVERLAY-18-G5_Perfect_Stocking_Fillers.jpg",
            "Overlay-G5_CollagenBundle.jpg" : "ES-Paquete_G5_de_colageno.jpg",
            "Overlay-G5_Sports_Recovery_Bundle_929e77b6-2461-4090-8b03-392510d18f54.jpg" : "ES-Paquete_G5_de_recuperacion_deportiva.jpg",
            "Overlay-G5_LongevityBundle.jpg" : "ES-Paquete_G5_de_longevidad.jpg",
            "Overlay-G5_Joint_Care_Bundle.jpg" : "ES-Paquete_G5_de_cuidado_articular.jpg",
            "Overlay-G5_The_Lotion_with_MMST_200ml_-_Regenerate_Skin.jpg" : "ES-Locion_con_MMST_G5_200_ml.jpg",
            "Overlay-G5_The_Cleanser_with_MMST_200ml_-_Purify_Skin.jpg" : "ES-Limpiador_con_MMST_G5_200_ml.jpg",
            "Overlay-G5_The_Mist_with_MMST_100ml_-_Revitalise_Skin.jpg" : "ES-Bruma_con_MMST_G5_100_ml.jpg",
            "Overlay-G5_Winter_Wellness_Gift_Collection.jpg" : "OVERLAY-20-G5_Winter_Wellness_Gift_Collection.jpg",
            "Overlay-G5_The_Gel_100ml_-_Soothe_Skin.jpg" : "ES-Gel_G5_100_ml.jpg",
            "Overlay-G5_Christmas_Luxury_Skin_Collection.jpg" : "OVERLAY-19-_G5_Christmas_Luxury_Skin_Collection.jpg",
            "Overlay-G5_Haute_Cosmetiques_Bundle.jpg" : "ES-Paquete_G5_Haute_Cosmetiques.jpg",
            "Overlay-G5_The_Balm_100ml_-_Repair_Skin.jpg" : "ES-Balsamo_G5_100_ml.jpg",
            "Overlay-G5_Wellbeing_Starter_Bundle.jpg" : "ES-Paquete_inicial_G5de_bienestar.jpg",
            "Overlay-Buy_3_Get_One_Free.jpg" : "OVERLAY-17-Buy_3_Get_One_Free.jpg"
        };

        function updateImages() {
            const images = document.querySelectorAll('.product-block__image img');
            images.forEach((img) => {
                ['src', 'srcset'].forEach(attr => {
                    let val = img.getAttribute(attr);
                    if (!val) return;
                    if (attr === 'src') {
                        const updated = replaceFilename(val);
                        if (updated !== val) img.setAttribute(attr, updated);
                    } else if (attr === 'srcset') {
                        const updated = val.split(',')
                            .map(part => replaceFilename(part.trim()))
                            .join(', ');
                        img.setAttribute(attr, updated);
                    }
                });
            });
        }

        function replaceFilename(url) {
            const [path, query = ''] = url.split('?');
            const filename = path.split('/').pop();
            const dirname = path.substring(0, path.length - filename.length);
            const replacement = urlPairs[filename];
            if (replacement) {
                return `${dirname}${replacement}${query ? '?' + query : ''}`;
            }
            return url;
        }

        updateImages();

        setTimeout(updateImages, 1000);

        const cartLink = document.querySelector('.cart-link');
        if (cartLink) {
            cartLink.addEventListener('click', function () {
                setTimeout(updateImages, 500);
            });
        }
    }
});

// Locale images
document.addEventListener('DOMContentLoaded', function () {
    const isEsLocale =
        window.location.pathname.includes('/es/') ||
        window.location.pathname.endsWith('/es');

    const EsOnlyImages = [
        "67786800333145",
        "67786800234841",
        "67786800169305",
        "67786800398681",
        "67786799612249",
        "67786800103769"
    ];

    function enforceEsOnlyImages() {
        document.querySelectorAll(`
            .gallery-viewer__thumbs .gallery-viewer__thumb,
            .media-gallery__inner .slider__item,
            .product-block__image
        `).forEach(item => {
            const mediaId = item.getAttribute('data-media-id');
            if (!mediaId) return;

            if (EsOnlyImages.includes(mediaId)) {
                if (isEsLocale) {
                    item.style.display = ''; // show
                } else {
                    item.style.display = 'none';
                }
            }
        });
    }

    enforceEsOnlyImages();

    const observer = new MutationObserver(() => {
        enforceEsOnlyImages();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  
    const mainImage = document.querySelector('.main-image');
    if (mainImage) {
        mainImage.addEventListener('click', () => {
            let attempts = 0;
            const maxAttempts = 20;

            const interval = setInterval(() => {
                enforceEsOnlyImages();
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 300);
        });
    }

    document.querySelectorAll('.product-block').forEach(block => {
        block.addEventListener('click', () => {
            let attempts = 0;
            const maxAttempts = 20;
            const interval = setInterval(() => {
                enforceEsOnlyImages();
                attempts++;
                if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 300);
        });
    });
});

